import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

const navItems = [
  { to: "/", label: "Home" },
  { to: "/#products", label: "Products" },
  { to: "/support", label: "Support" },
  { to: "/privacy", label: "Privacy" },
  { to: "/contact", label: "Contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 backdrop-blur-md"
      style={{
        background: "rgba(11, 18, 32, 0.78)",
        borderBottom: "1px solid var(--af-border)",
      }}
    >
      <div className="af-container flex items-center justify-between" style={{ height: 68 }}>
        <Link to="/" data-testid="brand-link" className="flex items-center gap-2.5" style={{ textDecoration: "none" }}>
          <span
            aria-hidden
            style={{
              width: 26,
              height: 26,
              borderRadius: 6,
              background: "linear-gradient(135deg, #1B365D 0%, #6B46C1 130%)",
              border: "1px solid var(--af-border-strong)",
              display: "inline-block",
            }}
          />
          <span style={{ color: "#fff", fontWeight: 700, letterSpacing: "-0.01em" }}>
            AithorityForge <span style={{ color: "var(--af-text-muted)", fontWeight: 500 }}>Solutions Ltd.</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-7" data-testid="primary-nav">
          {navItems.slice(0, 4).map((it) => (
            <NavLink
              key={it.label}
              to={it.to}
              data-testid={`nav-link-${it.label.toLowerCase()}`}
              className={({ isActive }) => `af-nav-link ${isActive && it.to === "/" ? "active" : ""}`}
            >
              {it.label}
            </NavLink>
          ))}
          <Link
            to="/contact"
            data-testid="header-contact-btn"
            className="af-btn af-btn-primary"
            style={{ padding: "0.55rem 1rem", fontSize: "0.88rem" }}
          >
            Contact Us
          </Link>
        </nav>

        <button
          aria-label={open ? "Close menu" : "Open menu"}
          data-testid="mobile-menu-toggle"
          className="md:hidden"
          onClick={() => setOpen((v) => !v)}
          style={{
            background: "transparent",
            border: "1px solid var(--af-border-strong)",
            color: "var(--af-text)",
            borderRadius: 8,
            padding: 8,
            cursor: "pointer",
          }}
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-nav"
          className="md:hidden"
          style={{ borderTop: "1px solid var(--af-border)", background: "var(--af-bg)" }}
        >
          <div className="af-container flex flex-col gap-2 py-4">
            {navItems.map((it) => (
              <NavLink
                key={it.label}
                to={it.to}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${it.label.toLowerCase()}`}
                className="af-nav-link"
                style={{ padding: "0.6rem 0" }}
              >
                {it.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              onClick={() => setOpen(false)}
              data-testid="mobile-header-contact-btn"
              className="af-btn af-btn-primary mt-2"
              style={{ alignSelf: "flex-start" }}
            >
              Contact Us
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
